import * as z from 'zod';

export const CreateProductSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, {
    message: 'Name is required!',
  }),
  price: z.number().min(0.01, {
    message: 'Price must be at least 0.01',
  }),
  sku: z.string().max(50).optional().nullable(),
  description: z.string().max(500).optional().nullable(),
  unit: z.string().max(30).optional().nullable(),
});
